// SPDX-FileCopyrightText: 2022 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2022 Ewan Cahen (Netherlands eScience Center) <e.cahen@esciencecenter.nl>
// SPDX-FileCopyrightText: 2022 Netherlands eScience Center
// SPDX-FileCopyrightText: 2022 dv4all
//
// SPDX-License-Identifier: Apache-2.0

export const maintainers = {
  title:'Maintainers',
  inviteLink: {
    title: 'Invite Maintainer',
    subtitle: 'Create invite link <strong>per person</strong> and send an e-mail or share directly.'
  }
}
